import axios from 'axios';

const baseUrl = 'https://regagen-pc-api.blackdot.co.me/api/';
const translationsUrl = `${baseUrl}translations-rendered`;
const navigationLinksUrl = `${baseUrl}menus`;
const dealsUrl = `${baseUrl}provider-rates`;
const distributorsUrl = `${baseUrl}distributors`;
const customerTypesUrl = `${baseUrl}customer-types`;
const suppliersUrl = `${baseUrl}suppliers`;
const staticContentUrl = id => `${baseUrl}contents/${id}`;

const get = url => axios.get(url)
  .then(response => response.data)
  .catch(error => Promise.reject(error));

export const getTranslations = () => get(translationsUrl);
export const getNavigationLinks = () => get(navigationLinksUrl);
export const getDeals = () => get(dealsUrl);
export const getDistributors = () => get(distributorsUrl);
export const getCustomerTypes = () => get(customerTypesUrl);
export const getSuppliers = () => get(suppliersUrl);
export const getStaticContent = id => get(staticContentUrl(id));
